import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";

export default function UpgradeModal({ open, onClose, onUpgrade, title, subTitle }) {
  const handleClose = (event, reason) => {
    // Prevent closing on backdrop click or Escape
    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown
      aria-labelledby="upgrade-modal-title"
      aria-describedby="upgrade-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 480,
          height: 250,
          bgcolor: "#f9f9f9",
          borderRadius: 3,
          boxShadow: 24,
          p: 4,
          textAlign: "center",
          maxWidth: 480,
          background: "linear-gradient(135deg, #1e3a8a, #3b82f6)",
        }}
      >
        <Typography
          id="upgrade-modal-title"
          variant="h5"
          component="h2"
          gutterBottom
          sx={{
            fontWeight: 700,
            color: "#fff",
          }}
        >
         {title}
        </Typography>
        <Typography
          id="upgrade-modal-description"
          sx={{
            mb: 2,
            mt: 2,
            color: "#fff",
            fontWeight: 500,
            fontSize: "1.1rem",
            maxWidth: 280,
            margin: "0 auto",
          }}
        >
          {subTitle}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={onUpgrade}
          sx={{
            padding: "12px 25px",
            fontSize: "1.1rem",
            fontWeight: 600,
            backgroundColor: "#fb923c",
            color: "#fff",
            mt: 3,
            borderRadius: 20,
            "&:hover": {
              backgroundColor: "#f97316",
              color: "#fff",
            },
          }}
        >
          Upgrade Now
        </Button>
      </Box>
    </Modal>
  );
}
